
seedWebApp.controller('ProcExpCtrl', ['$scope', '$uibModalInstance', '$window', 'StoreService', '$timeout', 'item',
    function EditBoxCtrl($scope, $uibModalInstance, $window, StoreService, $timeout, item) {
        console.log('ProcExpCtrl');
        //console.log(box);

        $scope.item = item;
        //$scope.box = box;

        $scope.ok = function () {
            $uibModalInstance.close();
        };

        $scope.openNewTab = function (version) {
            var newUrl = version.Image;
            $window.open(newUrl, '_blank');
            $scope.cancel();
        };


        $scope.getExpenses = function (procexpID) {
            StoreService.getExpenses(procexpID).then(function (response) {
                $scope.loading = false;
                $scope.expenses = response.data.expenses;                
            }, function () {
                $scope.loading = false;
            })
        }

        $scope.getExpenses($scope.item.ProcExpID);

        $scope.doPrint = function () {
            $window.print();
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

    }
]);